import { TextInput, Button } from '@undertheground/react';
import colors from '@undertheground/color';
import ButtonCover from "../../../../src/images/ButtonIcon/ButtonCover.png";
import InputImage from "../../../../src/images/InputCover.png";
import * as React from 'react';
export default {
  TextInput,
  Button,
  colors,
  ButtonCover,
  InputImage,
  React
};